import { icons } from './icons.ts';
import { GridItem } from './interface.ts';

export const projects: GridItem[] = [
  {
    id: 1,
    icon: icons.objc,
    title: 'The Social Network',
    content: `2013 - 2018
    <end>I Began as a iOS developer (Objective-C)
    <end><i>Had collaborated within a 6-members engineering team to develop a huge social networking platform (Vodi) featuring messaging, over internet voice calls, virtual gifting, match viewing -betting, and mobile/top-up gift card purchasing</i>
    <end><b>Role & responsibility</b>
    <end><tab>• Implemented user interfaces based on finalized design specifications, ensuring high fidelity and performance.
    <end><tab>• Resolved defects and optimized application stability across multiple iOS versions and devices.
    <end><tab>• Conducted code reviews to maintain code quality, consistency, and best practices.
    <end><tab>• Architectured and scaled ideas and technical insights to enhance product features and overall user experience.
    <end><b>Technical stack</b>
    <end><tab>• iOS with Objective-C, CocoaPods for packages management
    <end><tab>• MVC with storyboard and xib for UIs implement
    <end><tab>• APNS and In app purchasing
    <end><tab>• WebRTC for real-time communications
    <end><tab>• AFNetworking, SDWebImage
    `,
  },
  {
    id: 2,
    icon: icons.swift,
    title: 'Picture Sharing',
    content: `2013 - 2014 - iOS Swift developer
    <end>Built an Instagram-like native iOS app with 3-people team, where users could upload, edit, and share images and videos. Implemented smooth media editing workflows, real-time feed updates, and interactive engagement features (likes, comments, notifications).
    <end>Focused on building a fast and polished user experience leveraging Swift and iOS native frameworks.`,
  },
  {
    id: 3,
    icon: icons.swift,
    title: 'Finstro Pay',
    content: `2018 - 2020
    <end>Mobile Developer - Mobile lead (iOS – Swift)
    <end><b>Role & responsibility</b>
    <end><tab>• To create an application for Australian customers supporting online/offline transactions, e-gift card purchases, and installment services.
    <end><tab>• Integrated advanced technologies such as OCR card scanning, Apple Pay, and fraud detection mechanisms.
    <end><b>Technical stack</b>
    <end><tab>• iOS with Swift
    <end><tab>• MVVM with SwiftUI
    <end><tab>• Apple Pay - integrate with NAB payment system
    <end><tab>• LocalAuthentication framework (FaceID/TouchID)
    <end><tab>• OCR card scanning and integrate with 3rd fraud detection mechanisms
    <end><tab>• Networking with Alamofire
    `,
  },
  {
    id: 4,
    icon: icons.rn,
    title: 'WebsterPak',
    content: `2020 - 2026, Webstercare - Australian healthcare
    <end>Mobile and Web frontend developer - (React Native/Angular/C#)
    <end><b>Role & responsibility</b>
    <end><tab>• To create a mobile healthcare assistant app that helps patients manage prescriptions and medication reminders while staying connected with doctors or caregivers.
    <end><tab>• I also extended the ecosystem with an Angular-based web portal for administrators to monitor and manage patients. Tech stack included React Native (JS), Angular (TS), and native modules (Objective-C, Java) with Azure Notification Service integration for real-time alerts.
    <end><tab>• Developed a reporting web platform for them, providing interactive dashboards and data visualization.
    <end><tab>• Integrated Telerik and Crystal Reports for generating dynamic financial and medical reports. Improved performance of large dataset rendering and ensured compliance with healthcare data security standards.
    <end><b>Technical stack</b>
    <end><tab>• <b>React Native</b>, <b>Angular</b> with Javascript and Typescript
    <end><tab>• Java and Objective-C for native modules
    <end><tab>• C# for reporting services
    <end><tab>• Telerik reporting service, Telerik template designer and Crystal to create reports
    <end><tab>• Clean architecture with Redux for mobile app
    <end><tab>• Angular for management portal and report web viewer
    <end><tab>• 2 Ways communication powered by Azure Notification Service and APNS
    <end><tab>• CI/CD with Azure devops
    <end><tab>• Networking with Axios
    `,
  },
  {
    id: 5,
    icon: icons.rn,
    title: 'Delivery Platforms',
    content: `2021 - 2022
    <end>Mobile Developer (React Native) for Express Food & Medicine Delivery, <b>the delivery platform</b>
    <end>Led development of mobile apps for food and medicine delivery services in the US and Vietnam. Designed intuitive ordering workflows, integrated real-time GPS tracking for couriers, and implemented secure payment gateways. Focused on optimizing scalability to handle high daily order volumes while ensuring a reliable customer experience.
    <end><b>Role & responsibility</b>
    <end><tab>• Implemented user interfaces based on finalized design specifications, ensuring high fidelity and performance.
    <end><tab>• Resolved defects and optimized application stability across multiple iOS versions and devices.
    <end><tab>• Conducted code reviews to maintain code quality, consistency, and best practices.
    <end><tab>• Architectured and scaled ideas and technical insights to enhance product features and overall user experience.
    <end><b>Technical stack</b>
    <end><tab>• React Native with some native modules
    <end><tab>• Clean architecture support by Redux
    <end><tab>• Route planning and location tracking with GPS system and Google Map
    <end><tab>• Realtime communications powered by Google FCM
    <end><tab>• Payment gateway integration with Paypal, credit cards
    `,
  },
  {
    id: 6,
    icon: icons.rn,
    title: 'We1Care',
    content: `In 2021
    <end>Developer - (React Native/ReactJS)
    <end><b>Role & responsibility</b>
    <end><tab>• Researched and implemented a blockchain-based platform from scratch for storing and managing patient records, giving doctors secure and traceable access to medical history and prescriptions.
    <end><tab>• Designed both the ReactJS-based web system and React Native mobile apps, handling system architecture, smart contract integration, and user authentication with a strong emphasis on security and privacy.
    <end><b>Technical stack</b>
    <end><tab>• Self-build blockchain based on Typescript system, fully run on browser or mobile app
    <end><tab>• SocketIO to send and receive event, serverless
    `,
  },
  {
    id: 7,
    icon: icons.flutter,
    title: 'Job Posting',
    content: `In 2023
    <end>A mobile developer - (Flutter)
    <end>To maintain and deliver a Flutter application for US customers (Axero) to post, search, and apply for jobs. Features included personalized job recommendations, resume uploads, real-time chat between recruiters and candidates, and push notifications for job alerts. Focused on cross-platform performance and consistent UI across Android and iOS.
    <end><b>Technical stack</b>
    <end><tab>• Flutter, Dart
    <end><tab>• Clean architecture, state management with Cubit
    <end><tab>• Networking with Dio
    <end><tab>• CI/CD supported by Github action
    `,
  },
  {
    id: 8,
    icon: icons.rn,
    title: 'RN Fintech Apps',
    content: `2020 - 2023
    <end>A mobile developer - (React native)
    <end>Contributed to a suite of fintech applications for banking partners, enabling users to transfer money, pay bills, purchase gift cards, and apply for loans. Implemented strong encryption for transactions, biometric authentication, and a modular architecture to support multiple banking clients with customizable features.`,
  },
  {
    id: 10,
    icon: icons.ionic,
    title: 'Internal Social Network',
    content: `2023
    <end>A mobile developer - (Ionic)
    <end>Built a private enterprise social network for a US company, enabling employees to connect through posts, chat, document sharing, task management, and reward systems.
    <end>Leveraged Ionic for hybrid mobile development, focusing on rich features while maintaining internal data security and performance at scale.`,
  },
  {
    id: 101,
    icon: icons.rn,
    title: 'DLP Manager',
    content: `2023 - 2024
    <end>A mobile developer - (React native/Expo) for The digital backbone for post-construction handover.
    <end>DLP Manager is a cutting-edge mobile solution designed to streamline the handover and defect management process for the construction and real estate industries. By digitizing manual workflows, the app connects developers, contractors, and residents on a single, seamless interface.
    <end><b>Technical stack</b>
    <end><tab>• Expo, React native
    <end><tab>• CI/CD with EAS
    `
  },
  {
    id: 11,
    icon: icons.rn,
    title: 'Bored Radio',
    content: `In 2023
    <end>A freedom contributor
    <end>My personal side project to experiment with Angular and Firebase.
    <end>To created a web-based "bored radio" streaming my favorite songs, with a companion mobile app that allowed users to upload and share their own tracks.
    <end>Implemented Google Firebase (Realtime Database) for storage and synchronization.`,
  },
  {
    id: 12,
    icon: icons.rn,
    title: 'The Color Wallet',
    content: `In 2022
    <end>Another personal side. Designed and developed a simple but creative React Native app that allows users to capture, save, and organize favorite colors for design inspiration. Added sharing features so users can export palettes to design tools, and used local storage for offline usage.`,
  },
  {
    id: 13,
    icon: icons.rn,
    title: 'E-Banking',
    content: `2024 - 2025
    <end>A mobile developer - (React native)
    <end>This is a flagship Super App by <b>HDBank</b>, providing a comprehensive suite of digital banking solutions for individual customers. Within this project, I contributed to developing and maintaining several core modules, including critical components such as password management, account services, and biometric authentication.
    <end><b>Technical stack</b> Super-App/Mini-App Architecture, Clean Architecture with React Native
    <end><b>Key Contributions</b> 
    <end>• Implemented high-security components including Biometric Authentication (FaceID/TouchID)
    <end>• Encrypted password management, and seamless account service workflows.
    <end>• Handled advanced React Native techniques under strict NDA and security compliance.
    `,
  },
  {
    id: 17,
    icon: icons.flutter,
    title: 'MAXM',
    content: `2025 - now
    <end>Mobile developer - (Flutter)
    <end>A specialized healthcare platform for post-injury recovery integrated with wearable IoT sensors, real-time biometric data to provide personalized rehabilitation plans and progress tracking.
    <end><b>Technical stack</b> Flutter, Feature-First Architecture, Dio, Socket.IO, Multi-environment flavors.
    <end><b>Key Contributions</b>
    <end><tab>• Integrated AI-driven assistants for instant patient support.
    <end><tab>• Implemented real-time chat with supporters via Socket.IO.
    <end><tab>• Leveraged AI-assisted development (Cursor) and Antigravity to optimize code quality and velocity.
    <end><tab>• Multiple environment deploy with flavor
    `,
  },

  {
    id: 171,
    icon: icons.flutter,
    title: 'Project Hail Design',
    content: `2026
    <end>Mobile developer - (Flutter)
    <end>Hail Design is a Flutter-based experimental tool designed to explore the practical utility of AI in the design workflow. By leveraging Gemini via Google AI Studio, the app allows users to upload or capture a UI design for instant analysis. The AI evaluates the design, provides a performance score, and offers a witty, lighthearted critique, demonstrating how generative AI can serve as both a functional assistant and a creative companion.
    <end><b>Technical stack</b> Flutter, Gemini API from Google AI studio.
    <end><b>Key Contributions</b>
    <end><tab>• The person who came up with the idea and executed it.
    <end><tab>• Interface design and editing.
    `,
  },

  {
    id: 172,
    icon: icons.flutter,
    title: 'Project Mono Eyes',
    content: `2026
    <end>Mobile developer - (Flutter)
    <end>Project Mono Eyes is a Flutter-based mobile application dedicated to the art of black-and-white photography. Designed as a modern alternative to Lenka, it streamlines the mobile shooting experience with a focus on high-contrast aesthetics and precise light manipulation. The project explores the intersection of minimalist UI and real-time image processing to deliver professional-grade monochrome captures.
    `,
  },
  {
    id: 16,
    icon: icons.rn,
    title: 'More',
    content: `Beyond my main expertise, I have successfully delivered a wide range of independent and freelance projects.<end>My portfolio includes developing mobile applications, immersive games, and custom automation tools designed to solve specific problems and optimize personal workflows. This diverse background demonstrates my technical versatility and ability to adapt quickly to different platforms, languages, and project requirements to provide effective digital solutions.`,
  },
];
